const destinations = [
    {
        name: 'Reykjavík, Iceland',
        image: 'https://images.unsplash.com/photo-1518156959312-07a5380c1261?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2302&q=80',
        imgAlt: 'Collect moments in Iceland',
        price: '$556',
        deal: '3 nights hotel + Round-trip flight'
    },
    {
        name: 'Amalfi, Italy',
        image: 'https://images.unsplash.com/photo-1633321088355-d0f81134ca3b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80',
        imgAlt: 'Soak in the view of the Amalfi Coast, Italy',
        price: '$749',
        deal: '3 nights hotel + Round-trip flight'
    },
    {
        name: 'Paris, France',
        image: 'https://images.unsplash.com/photo-1591289009723-aef0a1a8a211?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80',
        imgAlt: 'Escape the ordinary in the streets of Paris',
        price: '$598',
        deal: '3 nights hotel + Round-trip flight'
    }
]

export default destinations;